var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFloatingRocks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 842,
    height: 259,
    viewBox: "0 0 842 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M697.068 86.2961C697.068 86.2961 693.061 91.085 687.959 96.2284C684.254 100.136 680.189 103.604 675.831 106.574L671.17 109.161L632.957 130.34L630.82 134.774L629.151 138.203L627.695 141.159L618.532 154.964C618.532 154.964 608.996 155.393 604.415 154.964L592.394 139.888L585.422 131.02L581.001 125.463L576.527 123.837L572.947 122.537L566.977 120.29L555.183 108.023L552.672 105.421L550.362 103.012L545.393 97.8542L540.05 92.3265C540.05 92.3265 544.151 86.7248 547.062 85.2172L552.138 73.7923C552.138 73.7923 572.854 52.4501 583.726 46.8485C609.355 41.0588 635.479 38.3874 661.633 38.8821L663.784 51.1643L670.983 50.307L681.133 64.3035L688.239 74.1027L695.118 83.5767L695.545 84.1679L697.068 86.2961Z",
    fill: "url(#paint0_linear_594_27251)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M576.073 52.0066L581.776 83.0445L596.962 96.8933L597.75 102.022L596.187 113.225L610.799 143.834L604.468 154.831L581.095 125.404L566.964 120.29L540.091 92.3264L547.57 84.0348L552.165 73.7922C552.165 73.7922 570.596 55.805 576.073 52.0066Z",
    fill: "url(#paint1_linear_594_27251)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.439 96.9082L581.802 83.0594L642.761 74.4722L639.061 81.1231L596.988 96.9082C596.988 96.9082 578.076 99.3026 564.439 96.9082Z",
    fill: "url(#paint2_linear_594_27251)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M566.977 120.305L597.75 102.037L631.448 93.1984L697.081 86.2961L675.858 106.559L633.011 130.267L596.187 113.24L582.564 125.419L566.977 120.305Z",
    fill: "url(#paint3_linear_594_27251)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.468 154.846L610.799 143.849L627.735 141.041C627.735 141.041 622.486 151.387 618.586 154.846H604.468Z",
    fill: "url(#paint4_linear_594_27251)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M639.048 81.1232L663.784 51.1642L661.633 38.8821L642.747 74.4722L639.048 81.1232Z",
    fill: "url(#paint5_linear_594_27251)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.892 84.5669L581.255 80.2216L588.24 82.3942L579.892 84.5669Z",
    fill: "#756AC9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M609.53 141.189L608.462 148.668L613.003 143.48L609.53 141.189Z",
    fill: "#756AC9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.439 96.9082L597.75 102.037L631.448 93.1984L639.048 81.1232L596.975 96.9082H564.439Z",
    fill: "url(#paint6_linear_594_27251)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M688.239 74.1765C686.811 73.5778 685.463 72.7674 684.232 71.7673C676.914 66.1396 668.771 61.9544 660.164 59.3965C657.998 58.899 655.907 58.0629 653.953 56.9134C653.178 56.3026 652.334 55.8058 651.442 55.4354C650.355 55.192 649.232 55.2224 648.157 55.5242C627.174 59.3669 604.749 54.8147 585.101 63.8453C582.77 64.8241 580.597 66.2115 578.664 67.9542C575.231 71.2057 573.321 76.0092 570.142 79.6008C567.471 82.6454 564.052 84.7146 561.033 87.3011C556.761 90.8288 553.335 95.4622 551.056 100.795C550.79 101.536 550.558 102.29 550.362 103.057L545.393 97.8984C552.872 90.0206 561.768 83.813 568.326 74.9007C572.132 69.7277 575.552 63.9636 580.627 60.3868C584.928 57.3569 590.043 56.1449 595.065 55.1842C612.989 51.7849 631.221 50.8833 649.399 49.9965C651.292 49.8257 653.197 49.9002 655.075 50.2182C656.536 50.5772 657.959 51.1021 659.323 51.7848C666.907 55.2669 674.205 59.4703 681.133 64.3477L688.239 74.1765Z",
    fill: "#C39ECB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M696.133 85.5421C683.284 84.6406 671.851 76.6742 659.603 72.2402C638.647 64.7319 615.928 68.0576 594.157 71.4718C590.773 71.8198 587.45 72.6955 584.287 74.073C580.736 76.0731 577.542 78.767 574.857 82.0247C572.733 84.3451 561.501 100.204 555.237 108.037L552.726 105.436C554.951 103.691 556.958 101.629 558.696 99.3024C564.533 92.0897 570.837 85.0989 576.3 77.5463C577.64 75.6808 579.263 74.0856 581.094 72.8314C582.658 71.9905 584.322 71.4032 586.036 71.0875C605.109 66.5463 624.472 63.6555 643.949 62.4412C645.165 62.2145 646.414 62.471 647.475 63.1654C648.384 63.934 648.811 65.2494 649.492 66.1214C651.563 68.7079 655.289 67.5107 658.401 67.5994C662.555 67.7768 666.161 70.6439 669.741 72.9792C675.666 76.8568 682.178 79.5111 688.96 80.8126C691.124 81.2412 693.675 81.8473 695.118 83.4583L695.545 84.0495C695.833 84.4961 696.033 85.0045 696.133 85.5421Z",
    fill: "#C39ECB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M630.874 134.641L629.204 138.07C622.645 133.779 615.381 130.971 607.834 129.808C605.499 129.26 603.071 129.46 600.835 130.385C599.25 131.343 597.859 132.651 596.748 134.228C595.306 136.031 593.908 137.878 592.554 139.77L585.582 130.902C590.364 127.946 595.88 124.162 600.995 124.044C602.69 124.069 604.376 124.317 606.017 124.783L620.923 128.286C623.652 128.712 626.266 129.78 628.59 131.419C629.572 132.277 630.355 133.381 630.874 134.641Z",
    fill: "#C39ECB"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M687.985 96.2284C684.28 100.136 680.216 103.604 675.858 106.574L671.196 109.161C665.854 104.535 658.027 104.638 651.068 105.096L628.229 106.574C617.544 107.284 606.712 108.052 596.454 111.452C589.077 113.826 582.292 118.043 576.62 123.778L573.041 122.478C576.853 119.764 580.804 117.297 584.874 115.088C590.671 111.363 596.521 107.594 602.932 105.422C613.737 101.756 625.304 102.85 636.577 102.126C653.78 101.091 670.863 95.652 687.985 96.2284Z",
    fill: "url(#paint7_linear_594_27251)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M552.178 73.7923L554.021 80.9163L579.732 71.9005L588.24 64.141L608.194 66.5945L651.509 52.9969L657.186 51.9476L661.633 38.8821L663.784 51.1642L670.983 50.307L655.356 54.6966L609.771 67.4961L590.791 70.0087L579.892 73.7037L554.115 82.8525L547.103 85.2173L552.178 73.7923Z",
    fill: "url(#paint8_linear_594_27251)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M663.784 51.1641L655.756 53.7802L616.809 65.0721L609.771 67.496L590.791 70.0086L579.892 73.7036L552.672 82.8524L547.103 85.2171L543.59 88.454L577.221 76.4379L579.892 74.4721L591.219 71.4274L603.6 69.0922L611.827 70.3189L625.224 63.8453L656.357 55.6277L670.983 50.3069L663.784 51.1641Z",
    fill: "#756ABA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M657.546 90.405L670.943 86.2961L677.554 88.3506L666.949 90.9371L657.546 90.405Z",
    fill: "url(#paint9_linear_594_27251)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M657.546 90.405L667.55 89.4L677.554 88.3506L666.949 91.8091L657.546 90.405Z",
    fill: "#7551BA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M632.81 158.068L635.722 169.493L649.559 172.729L651.509 161.733C651.509 161.733 650.922 154.343 642.734 150.958C642.734 151.032 634.173 155.053 632.81 158.068Z",
    fill: "url(#paint10_linear_594_27251)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M635.722 169.493L638.393 163.462L651.549 161.733L649.599 172.729C644.851 172.444 640.17 171.352 635.722 169.493Z",
    fill: "url(#paint11_linear_594_27251)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.46 -2.78262L341.669 8.68646L352.033 19.3133L358.805 10.9922C358.805 10.9922 361.703 4.37079 356.294 -3.24089C356.267 -3.24089 347.011 -4.58578 344.46 -2.78262Z",
    fill: "url(#paint12_linear_594_27251)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.642 8.68654L346.704 5.00635L358.725 10.9183L351.953 19.2395C348.055 16.3165 344.579 12.7587 341.642 8.68654Z",
    fill: "url(#paint13_linear_594_27251)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595.947 -1.92546L597.91 9.73595L611.413 14.3621L614.272 3.61702C614.272 3.61702 614.272 -3.77293 606.432 -8C606.432 -8 597.563 -4.79277 595.947 -1.92546Z",
    fill: "url(#paint14_linear_594_27251)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.91 9.73599L601.036 4.00136L614.272 3.61707L611.413 14.3621C606.725 13.5939 602.171 12.0337 597.91 9.73599Z",
    fill: "url(#paint15_linear_594_27251)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.693 113.284L408.357 118.709L413.259 123.734L416.464 119.802C416.842 118.665 416.929 117.435 416.717 116.246C416.505 115.057 416.002 113.956 415.262 113.063C415.262 113.063 410.908 112.427 409.693 113.284Z",
    fill: "url(#paint16_linear_594_27251)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.37 118.709L410.761 116.964L416.478 119.802L413.272 123.734C411.418 122.343 409.765 120.649 408.37 118.709Z",
    fill: "url(#paint17_linear_594_27251)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.36 37.1085L525.024 42.5179L529.94 47.5579L533.132 43.6116C533.513 42.4783 533.603 41.2505 533.394 40.0638C533.184 38.8771 532.682 37.7777 531.943 36.8868C531.943 36.8868 527.575 36.2513 526.36 37.1085Z",
    fill: "url(#paint18_linear_594_27251)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M525.038 42.5178L527.429 40.7887L533.145 43.6115L529.953 47.5579C528.094 46.1626 526.436 44.4632 525.038 42.5178Z",
    fill: "url(#paint19_linear_594_27251)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.043 55.2878L201.708 60.7121L206.609 65.7373L209.815 61.8058C210.191 60.6707 210.278 59.4429 210.066 58.2568C209.854 57.0707 209.351 55.972 208.613 55.0808C208.613 55.0808 204.219 54.4306 203.043 55.2878Z",
    fill: "url(#paint20_linear_594_27251)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.721 60.712L204.112 58.9679L209.828 61.8057L206.623 65.7372C204.764 64.352 203.111 62.6569 201.721 60.712Z",
    fill: "url(#paint21_linear_594_27251)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.331 142.756L400.597 145.712L403.268 148.49L405.044 146.303C405.256 145.676 405.307 144.996 405.191 144.339C405.076 143.682 404.798 143.072 404.39 142.578C403.37 142.413 402.33 142.473 401.331 142.756Z",
    fill: "url(#paint22_linear_594_27251)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.557 145.771L401.892 144.795L405.058 146.362L403.281 148.549C402.25 147.783 401.331 146.846 400.557 145.771Z",
    fill: "url(#paint23_linear_594_27251)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M678.369 176.587L677.634 179.543L680.305 182.336L682.082 180.149C682.293 179.521 682.344 178.842 682.228 178.184C682.113 177.527 681.836 176.918 681.427 176.424C680.408 176.254 679.368 176.309 678.369 176.587Z",
    fill: "url(#paint24_linear_594_27251)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M677.661 179.587L678.996 178.627L682.162 180.193L680.385 182.381C679.355 181.606 678.437 180.664 677.661 179.587Z",
    fill: "url(#paint25_linear_594_27251)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.088 135.676L416.878 136.119L418.454 134.08L417.119 132.853C416.741 132.717 416.337 132.7 415.95 132.801C415.564 132.903 415.21 133.12 414.928 133.429C414.842 134.183 414.896 134.947 415.088 135.676Z",
    fill: "url(#paint26_linear_594_27251)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.878 136.119L416.277 135.188L417.119 132.853L418.454 134.08C418.026 134.845 417.495 135.533 416.878 136.119Z",
    fill: "url(#paint27_linear_594_27251)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.71 32.6301L390.499 33.0882L392.089 31.0339L390.753 29.8071C390.375 29.6715 389.971 29.6535 389.585 29.7551C389.199 29.8568 388.845 30.0743 388.563 30.3835C388.47 31.1355 388.52 31.9007 388.71 32.6301Z",
    fill: "url(#paint28_linear_594_27251)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.499 33.0882L389.898 32.1425L390.753 29.8071L392.089 31.034C391.657 31.8047 391.121 32.4974 390.499 33.0882Z",
    fill: "url(#paint29_linear_594_27251)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M590.017 22.6092L590.444 24.9444L594.451 26.6293L595.466 24.7376C595.466 24.7376 595.573 23.2596 593.249 22.0624C592.153 22.0644 591.063 22.2488 590.017 22.6092Z",
    fill: "url(#paint30_linear_594_27251)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M590.444 24.9444L591.472 24.0428L595.479 24.7376L594.464 26.6293C593.079 26.2084 591.733 25.6443 590.444 24.9444Z",
    fill: "url(#paint31_linear_594_27251)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.863 179.528L439.29 181.878L443.297 183.548L444.312 181.671C444.312 181.671 444.419 180.193 442.095 178.996C441 178.998 439.911 179.178 438.863 179.528Z",
    fill: "url(#paint32_linear_594_27251)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.29 181.878L440.319 180.962L444.325 181.671L443.297 183.548C441.916 183.136 440.574 182.577 439.29 181.878Z",
    fill: "url(#paint33_linear_594_27251)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M650.32 27.0136L650.761 29.349L654.768 31.0339L655.783 29.1421C655.783 29.1421 655.903 27.664 653.566 26.4668C652.465 26.4674 651.371 26.6517 650.32 27.0136Z",
    fill: "url(#paint34_linear_594_27251)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M650.694 29.349L651.723 28.4326L655.73 29.142L654.715 31.0339C653.329 30.615 651.983 30.0508 650.694 29.349Z",
    fill: "url(#paint35_linear_594_27251)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.523 168.236L187.95 170.571L191.957 172.256L192.972 170.364C192.972 170.364 193.079 168.96 190.755 167.689C189.659 167.69 188.569 167.875 187.523 168.236Z",
    fill: "url(#paint36_linear_594_27251)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.95 170.571L188.979 169.67L192.986 170.365L191.971 172.256C190.586 171.835 189.24 171.271 187.95 170.571Z",
    fill: "url(#paint37_linear_594_27251)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.015 109.649L412.804 110.107L414.394 108.067L413.058 106.84C412.682 106.699 412.278 106.677 411.891 106.777C411.504 106.876 411.15 107.092 410.868 107.402C410.777 108.154 410.827 108.919 411.015 109.649Z",
    fill: "url(#paint38_linear_594_27251)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.805 110.151L412.203 109.22L413.045 106.885L414.381 108.111C413.954 108.878 413.423 109.566 412.805 110.151Z",
    fill: "url(#paint39_linear_594_27251)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.286 107.313L423.089 107.757L424.665 105.717L423.329 104.49C422.952 104.355 422.547 104.337 422.161 104.438C421.775 104.54 421.421 104.757 421.139 105.067C421.053 105.819 421.103 106.583 421.286 107.313Z",
    fill: "url(#paint40_linear_594_27251)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.089 107.757L422.474 106.825L423.329 104.49L424.665 105.717C424.237 106.482 423.706 107.17 423.089 107.757Z",
    fill: "url(#paint41_linear_594_27251)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.058 6.32172L677.861 6.77999L679.437 4.71076L678.101 3.48409C677.724 3.34847 677.319 3.33045 676.933 3.43212C676.547 3.5338 676.193 3.75125 675.911 4.06053C675.823 4.8176 675.873 5.58634 676.058 6.32172Z",
    fill: "url(#paint42_linear_594_27251)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M677.861 6.78001L677.26 5.83407L678.102 3.4989L679.437 4.72557C679.008 5.49402 678.477 6.1866 677.861 6.78001Z",
    fill: "url(#paint43_linear_594_27251)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.925 52.5239L546.715 52.9674L548.305 50.9277L546.969 49.7009C546.591 49.5653 546.187 49.5474 545.801 49.6491C545.414 49.7508 545.061 49.9681 544.778 50.2773C544.687 51.0294 544.737 51.7942 544.925 52.5239Z",
    fill: "url(#paint44_linear_594_27251)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.715 52.9674L546.141 52.0067L546.982 49.6715L548.318 50.8982C547.886 51.6773 547.345 52.3758 546.715 52.9674Z",
    fill: "url(#paint45_linear_594_27251)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.094 236.268L135.433 237.111L138.358 233.312L135.874 231.021C135.181 230.783 134.441 230.757 133.736 230.947C133.03 231.137 132.384 231.536 131.867 232.1C131.867 232.1 131.48 235.382 132.094 236.268Z",
    fill: "url(#paint46_linear_594_27251)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.38 237.111L134.245 235.367L135.821 231.021L138.305 233.312C137.511 234.737 136.525 236.018 135.38 237.111Z",
    fill: "url(#paint47_linear_594_27251)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.561 7.38614L212.9 8.22852L215.839 4.43015L213.354 2.15398C212.653 1.89862 211.901 1.8628 211.182 2.0506C210.463 2.23839 209.805 2.64244 209.281 3.21809C209.281 3.21809 208.96 6.49934 209.561 7.38614Z",
    fill: "url(#paint48_linear_594_27251)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.847 8.22835L211.725 6.48424L213.301 2.15381L215.785 4.42998C214.988 5.85622 213.997 7.13744 212.847 8.22835Z",
    fill: "url(#paint49_linear_594_27251)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.303 215.133L139.093 215.591L140.682 213.552L139.347 212.31C138.969 212.174 138.565 212.157 138.178 212.258C137.792 212.36 137.438 212.577 137.156 212.886C137.065 213.639 137.115 214.403 137.303 215.133Z",
    fill: "url(#paint50_linear_594_27251)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.093 215.591L138.492 214.645L139.333 212.31L140.669 213.552C140.239 214.315 139.707 215.002 139.093 215.591Z",
    fill: "url(#paint51_linear_594_27251)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.563 34.2707L220.366 34.7142L221.942 32.6746L220.607 31.4477C220.229 31.3121 219.825 31.2943 219.438 31.3959C219.052 31.4976 218.698 31.7149 218.416 32.0242C218.331 32.7764 218.381 33.54 218.563 34.2707Z",
    fill: "url(#paint52_linear_594_27251)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.366 34.7731L219.765 33.842L220.607 31.5068L221.942 32.7335C221.515 33.4987 220.983 34.1867 220.366 34.7731Z",
    fill: "url(#paint53_linear_594_27251)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.591 226.942L141.884 228.952L144.182 229.81L144.716 227.977C144.686 227.535 144.545 227.112 144.309 226.754C144.073 226.396 143.751 226.118 143.38 225.952C143.38 225.952 141.871 226.41 141.591 226.942Z",
    fill: "url(#paint54_linear_594_27251)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.884 228.952L142.432 227.992H144.716L144.182 229.824C143.379 229.669 142.604 229.374 141.884 228.952Z",
    fill: "url(#paint55_linear_594_27251)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.678 79.6451L155.481 80.1033L157.057 78.0637L155.722 76.8222C155.344 76.6866 154.94 76.6686 154.553 76.7703C154.167 76.8719 153.813 77.0894 153.531 77.3987C153.445 78.1509 153.495 78.9144 153.678 79.6451Z",
    fill: "url(#paint56_linear_594_27251)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.481 80.0885L154.88 79.1425L155.722 76.8074L157.057 78.0488C156.625 78.8109 156.094 79.4982 155.481 80.0885Z",
    fill: "url(#paint57_linear_594_27251)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M539.343 59.6184L541.132 60.0617L542.708 58.022L541.373 56.7954C540.995 56.6597 540.591 56.6417 540.204 56.7434C539.818 56.8451 539.464 57.0625 539.182 57.3718C539.095 58.1249 539.15 58.8897 539.343 59.6184Z",
    fill: "url(#paint58_linear_594_27251)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.132 60.0616L540.531 59.1305L541.373 56.7953L542.708 58.022C542.281 58.7872 541.749 59.4751 541.132 60.0616Z",
    fill: "url(#paint59_linear_594_27251)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.973 248.698L558.055 252.275L562.502 253.073L562.97 249.541C562.8 248.748 562.436 248.022 561.917 247.443C561.399 246.864 560.746 246.455 560.032 246.26C560.032 246.26 557.36 247.708 556.973 248.698Z",
    fill: "url(#paint60_linear_594_27251)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.055 252.275L558.816 250.309L562.97 249.541L562.502 253.073C560.992 253.062 559.491 252.793 558.055 252.275Z",
    fill: "url(#paint61_linear_594_27251)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6067 235.175L43.6886 238.766L48.1496 239.564L48.6037 236.032C48.4337 235.239 48.0695 234.513 47.5511 233.934C47.0328 233.356 46.3803 232.946 45.6653 232.751C45.6653 232.751 42.994 234.199 42.6067 235.175Z",
    fill: "url(#paint62_linear_594_27251)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6886 238.766L44.4499 236.801L48.6037 236.032L48.1496 239.564C46.635 239.545 45.1315 239.276 43.6886 238.766Z",
    fill: "url(#paint63_linear_594_27251)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.194 162.235L482.859 167.66L487.76 172.685L490.966 168.739C491.347 167.605 491.437 166.378 491.228 165.191C491.018 164.004 490.516 162.905 489.777 162.014C489.777 162.014 485.41 161.378 484.194 162.235Z",
    fill: "url(#paint64_linear_594_27251)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482.872 167.66L485.263 165.916L490.979 168.739L487.774 172.685C485.922 171.29 484.27 169.596 482.872 167.66Z",
    fill: "url(#paint65_linear_594_27251)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7728 215.133L83.4371 220.557L88.3389 225.582L91.5311 221.636C91.9121 220.503 92.0027 219.275 91.7929 218.089C91.5832 216.902 91.0811 215.802 90.3423 214.911C90.3423 214.911 85.9882 214.276 84.7728 215.133Z",
    fill: "url(#paint66_linear_594_27251)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.4637 220.498L85.8545 218.754L91.5577 221.577L88.3655 225.523C86.5111 224.133 84.8583 222.438 83.4637 220.498Z",
    fill: "url(#paint67_linear_594_27251)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M812.199 191.485L815.124 202.91L828.948 206.132L830.898 195.15C830.898 195.15 830.31 187.761 822.136 184.376C822.136 184.376 813.562 188.47 812.199 191.485Z",
    fill: "url(#paint68_linear_594_27251)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M815.124 202.91L817.796 196.865L830.952 195.151L829.002 206.132C824.254 205.848 819.574 204.762 815.124 202.91Z",
    fill: "url(#paint69_linear_594_27251)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.906 152.082L581.602 158.718L589.616 160.61L590.738 154.21C590.493 152.748 589.889 151.389 588.991 150.283C588.093 149.178 586.937 148.368 585.649 147.943C585.649 147.943 580.694 150.323 579.906 152.082Z",
    fill: "url(#paint70_linear_594_27251)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M581.602 158.718L583.138 155.215L590.778 154.21L589.656 160.61C586.9 160.432 584.185 159.795 581.602 158.718Z",
    fill: "url(#paint71_linear_594_27251)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M795.09 173.01L796.519 178.612L803.304 180.193L804.252 174.813C804.046 173.578 803.535 172.431 802.776 171.497C802.017 170.563 801.039 169.88 799.952 169.522C799.952 169.522 795.758 171.532 795.09 173.01Z",
    fill: "url(#paint72_linear_594_27251)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M796.519 178.612L797.855 175.656L804.292 174.813L803.344 180.193C801.009 180.06 798.706 179.527 796.519 178.612Z",
    fill: "url(#paint73_linear_594_27251)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M755.515 125.419L755.381 125.921L751.628 139.327L733.317 151.032V162.043L725.143 168.281L715.179 143.908L712.922 138.425L710.117 131.567L705.723 120.793L698.644 103.5L703.131 93.2723L718.117 85.8823L720.268 89.119L743.054 85.8823C746.209 91.0114 748.713 96.5963 750.493 102.48C752.042 107.395 753.3 112.416 754.26 117.511C754.647 119.551 754.927 121.295 755.128 122.625C755.395 124.428 755.515 125.419 755.515 125.419Z",
    fill: "url(#paint74_linear_594_27251)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M703.118 93.1984L714.618 133.282L721.817 153.648L727.961 149.347L731.848 149.451L732.529 140.287C732.529 140.287 746.072 129.291 755.515 125.419L751.615 139.327L733.317 150.958V161.984L725.129 168.207L698.644 103.426L703.118 93.1984Z",
    fill: "url(#paint75_linear_594_27251)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M720.254 89.1043L732.529 140.287L755.515 125.419C755.515 125.419 751.909 96.7456 743.053 85.8676L720.254 89.1043Z",
    fill: "url(#paint76_linear_594_27251)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M754.26 117.497L750.253 117.807C742.56 118.199 734.901 119.186 727.333 120.763C725.813 121.108 724.31 121.542 722.832 122.064C717.919 123.882 713.543 127.141 710.17 131.493L705.776 120.719C706.152 118.799 706.998 117.03 708.22 115.605C709.278 114.677 710.525 114.053 711.853 113.787L750.587 102.465C752.104 107.383 753.331 112.404 754.26 117.497Z",
    fill: "#C39ECB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M755.515 125.419L755.381 125.921C752.443 126 749.514 126.217 746.593 126.571C740.919 127.119 735.354 128.614 730.085 131.005C724.225 133.857 719.102 138.282 715.179 143.879L712.922 138.395C714.831 135.686 717.166 133.378 719.813 131.582C723.07 129.442 726.581 127.815 730.245 126.749C738.335 124.15 746.705 122.773 755.128 122.655C755.395 124.429 755.515 125.419 755.515 125.419Z",
    fill: "#C39ECB"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M487.106 248.58L487.961 224.356C487.961 224.356 497.778 219.597 502.519 217.867L502.706 212.694L524.851 206.531L531.529 214.911L526.106 231.79L520.764 254.197L504.509 259L498.9 252.29L487.106 248.58Z",
    fill: "url(#paint77_linear_594_27251)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M487.119 247.545L499.38 243.673L500.703 250.782L517.211 245.609L520.831 254.211L504.589 259L498.966 252.29L487.119 248.536V247.545Z",
    fill: "url(#paint78_linear_594_27251)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.36,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.532 217.823L499.38 243.673L487.119 247.545L487.974 224.311L502.532 217.823Z",
    fill: "url(#paint79_linear_594_27251)"
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M517.211 245.609V223.41L524.851 206.487L531.583 214.867L525.038 236.475L520.831 254.211L517.211 245.609Z",
    fill: "url(#paint80_linear_594_27251)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.667 183.075L170.961 174.503C170.961 174.503 174.434 172.818 176.117 172.212L176.184 170.379L184.01 168.207L186.388 171.163L184.464 177.149L182.581 185.071L176.838 186.77L174.861 184.391L170.667 183.075Z",
    fill: "url(#paint81_linear_594_27251)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.667 182.721L175.008 181.346L175.476 183.859L181.312 182.041L182.595 185.071L176.851 186.77L174.861 184.406L170.667 183.075V182.721Z",
    fill: "url(#paint82_linear_594_27251)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.36,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.117 172.212L175.008 181.346L170.667 182.721L170.975 174.503L176.117 172.212Z",
    fill: "url(#paint83_linear_594_27251)"
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.312 182.041V174.193L184.01 168.207L186.388 171.163L184.077 178.804L182.595 185.071L181.312 182.041Z",
    fill: "url(#paint84_linear_594_27251)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08704 147.604L11.9673 157.506C20.0865 154.397 27.5453 149.483 33.885 143.066L37.1974 128.626L41.0975 123.527L34.0854 102.111C34.0854 102.111 17.9108 99.1548 2.52433 113.935L0 132.469L7.19905 137.849L4.08704 147.604Z",
    fill: "url(#paint85_linear_594_27251)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08704 147.603C4.08704 147.603 14.8923 139.622 27.4606 138.011L33.885 143.066C27.4735 149.375 20.0351 154.275 11.9673 157.506L4.08704 147.603Z",
    fill: "url(#paint86_linear_594_27251)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19905 137.893L27.4606 129.69V125.389C27.4606 125.389 15.9208 125.714 0 132.513L7.19905 137.893Z",
    fill: "url(#paint87_linear_594_27251)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0853 102.125L27.4606 108.599L26.2986 125.404L27.4606 129.69L30.1853 115.9L32.5761 113.92L27.4606 138.011L33.8983 143.081L37.1974 128.626L41.0974 123.527L34.0853 102.125Z",
    fill: "url(#paint88_linear_594_27251)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.0326 29.3639L69.5332 55.4503L78.8826 60.4018L101.468 55.4503L102.804 52.8786H108.841L112.594 47.2476L114.304 33.1326L110.016 30.8713L100.867 29.3933L100.667 24.2203L94.8168 21.2643C94.8168 21.2643 80.0046 22.6833 73.0326 29.3639Z",
    fill: "url(#paint89_linear_594_27251)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5332 55.4502C69.5332 55.4502 77.7206 49.6418 94.2691 49.8044L101.468 55.4502L78.8826 60.4017L69.5332 55.4502Z",
    fill: "url(#paint90_linear_594_27251)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0374 47.4693L102.831 52.8786H108.868L108.093 45.4886C108.093 45.4886 102.056 46.5973 99.0374 47.4693Z",
    fill: "url(#paint91_linear_594_27251)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8567 21.1757L94.269 49.8044L99.0373 47.4692L100.894 29.3638L100.693 24.1908L94.8567 21.1757Z",
    fill: "url(#paint92_linear_594_27251)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.043 30.8713L108.106 45.5331L108.881 52.8787L112.634 47.2475L114.33 33.1327L110.043 30.8713Z",
    fill: "url(#paint93_linear_594_27251)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.394 225.642L265.631 247.087L276.45 254.477L279.655 251.625L288.136 225.642L282.874 221.119L267.394 225.642Z",
    fill: "url(#paint94_linear_594_27251)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.631 247.087L278.934 243.437L279.655 251.625L276.45 254.477L265.631 247.087Z",
    fill: "url(#paint95_linear_594_27251)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.874 221.119L278.934 243.437L279.655 251.625L288.136 225.642L282.874 221.119Z",
    fill: "url(#paint96_linear_594_27251)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.166 175.582V190.081L374.472 195.254L381.604 190.081L384.85 175.582L381.604 172.463C376.65 172.404 371.737 173.466 367.166 175.582Z",
    fill: "url(#paint97_linear_594_27251)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.233 190.081L377.891 187.495L381.671 190.081L374.539 195.254L367.233 190.081Z",
    fill: "url(#paint98_linear_594_27251)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.671 172.463L377.891 187.494L381.671 190.081L384.903 175.582L381.671 172.463Z",
    fill: "url(#paint99_linear_594_27251)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.629 238.663V245.905L152.289 248.491L155.855 245.905L157.471 238.663L155.855 237.096C153.375 237.067 150.916 237.6 148.629 238.663Z",
    fill: "url(#paint100_linear_594_27251)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.643 245.905L153.972 244.619L155.855 245.905L152.289 248.491L148.643 245.905Z",
    fill: "url(#paint101_linear_594_27251)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.855 237.096L153.972 244.619L155.855 245.905L157.471 238.663L155.855 237.096Z",
    fill: "url(#paint102_linear_594_27251)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0974 184.243V197.308L47.6821 201.964L54.1065 197.308L57.0315 184.243L54.1065 181.42C49.6416 181.371 45.2147 182.331 41.0974 184.243Z",
    fill: "url(#paint103_linear_594_27251)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0975 197.308L50.7141 194.973L54.12 197.308L47.6822 201.979L41.0975 197.308Z",
    fill: "url(#paint104_linear_594_27251)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.12 181.435L50.7141 194.973L54.12 197.308L57.0317 184.243L54.12 181.435Z",
    fill: "url(#paint105_linear_594_27251)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.963 146.835V154.092L144.623 156.678L148.189 154.092L149.805 146.835L148.189 145.283C145.71 145.253 143.252 145.781 140.963 146.835Z",
    fill: "url(#paint106_linear_594_27251)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.976 154.092L146.305 152.791L148.189 154.092L144.622 156.678L140.976 154.092Z",
    fill: "url(#paint107_linear_594_27251)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.189 145.283L146.305 152.791L148.189 154.092L149.818 146.85L148.189 145.283Z",
    fill: "url(#paint108_linear_594_27251)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M746.486 49.3609V56.3518L742.987 58.8793L739.527 56.411L737.911 49.4201L739.46 47.9421C741.866 47.8713 744.258 48.3544 746.486 49.3609Z",
    fill: "url(#paint109_linear_594_27251)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M746.473 56.352L741.317 55.1548L739.501 56.4111L742.96 58.8793L746.473 56.352Z",
    fill: "url(#paint110_linear_594_27251)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M739.447 47.9126L741.317 55.1548L739.501 56.4111L737.898 49.4349L739.447 47.9126Z",
    fill: "url(#paint111_linear_594_27251)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.563 19.8972V27.1394L338.209 29.7259L341.775 27.1394L343.392 19.8972L341.775 18.3305C339.3 18.3017 336.845 18.835 334.563 19.8972Z",
    fill: "url(#paint112_linear_594_27251)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.563 25.0776L339.892 23.7917L341.789 25.0776L338.223 27.6641L334.563 25.0776Z",
    fill: "url(#paint113_linear_594_27251)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.789 16.2687L339.892 23.7917L341.789 25.0775L343.405 17.8354L341.789 16.2687Z",
    fill: "url(#paint114_linear_594_27251)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_594_27251",
    x1: 618.586,
    y1: 155.038,
    x2: 618.586,
    y2: 38.7934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D2887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#311B7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#240E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_594_27251",
    x1: 575.445,
    y1: 154.845,
    x2: 575.445,
    y2: 51.9475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6389FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5234DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_594_27251",
    x1: 603.587,
    y1: 97.9872,
    x2: 603.587,
    y2: 74.4722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#240061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_594_27251",
    x1: 566.977,
    y1: 108.289,
    x2: 697.081,
    y2: 108.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#240061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_594_27251",
    x1: 616.101,
    y1: 154.846,
    x2: 616.101,
    y2: 141.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#240061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_594_27251",
    x1: 651.416,
    y1: 81.1232,
    x2: 651.416,
    y2: 38.8821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01003E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_594_27251",
    x1: 564.439,
    y1: 91.5874,
    x2: 639.048,
    y2: 91.5874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77CBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451390"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_594_27251",
    x1: 573.041,
    y1: 109.989,
    x2: 687.985,
    y2: 109.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4513B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_594_27251",
    x1: 547.103,
    y1: 62.0571,
    x2: 670.983,
    y2: 62.0571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01003E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_594_27251",
    x1: 667.55,
    y1: 90.9371,
    x2: 667.55,
    y2: 86.2961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01003E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_594_27251",
    x1: 642.16,
    y1: 172.729,
    x2: 642.16,
    y2: 150.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#802C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#722B7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#532980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3D2882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#302783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_594_27251",
    x1: 635.722,
    y1: 167.231,
    x2: 651.509,
    y2: 167.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_594_27251",
    x1: 345.648,
    y1: 14.999,
    x2: 357.317,
    y2: -2.62788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_594_27251",
    x1: 342.667,
    y1: 6.63607,
    x2: 356.903,
    y2: 14.3324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_594_27251",
    x1: 607.727,
    y1: 20.7086,
    x2: 609.892,
    y2: -1.02308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_594_27251",
    x1: 601.75,
    y1: 14.5707,
    x2: 617.547,
    y2: 15.8555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_594_27251",
    x1: 410.243,
    y1: 121.625,
    x2: 415.761,
    y2: 113.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_594_27251",
    x1: 408.848,
    y1: 117.67,
    x2: 415.569,
    y2: 121.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_594_27251",
    x1: 526.908,
    y1: 45.4544,
    x2: 532.434,
    y2: 37.1079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_594_27251",
    x1: 525.513,
    y1: 41.4996,
    x2: 532.234,
    y2: 45.1329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_594_27251",
    x1: 203.603,
    y1: 63.6379,
    x2: 209.12,
    y2: 55.3034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_594_27251",
    x1: 202.208,
    y1: 59.683,
    x2: 208.928,
    y2: 63.3162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_594_27251",
    x1: 401.621,
    y1: 147.332,
    x2: 404.681,
    y2: 142.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_594_27251",
    x1: 400.842,
    y1: 145.145,
    x2: 404.576,
    y2: 147.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_594_27251",
    x1: 678.674,
    y1: 181.164,
    x2: 681.734,
    y2: 176.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_594_27251",
    x1: 677.895,
    y1: 178.977,
    x2: 681.616,
    y2: 180.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_594_27251",
    x1: 417.846,
    y1: 135.356,
    x2: 414.75,
    y2: 133.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_594_27251",
    x1: 416.576,
    y1: 135.987,
    x2: 418.09,
    y2: 133.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_594_27251",
    x1: 391.466,
    y1: 32.3153,
    x2: 388.37,
    y2: 30.7873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_594_27251",
    x1: 390.196,
    y1: 32.9457,
    x2: 391.71,
    y2: 30.4416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_594_27251",
    x1: 592.721,
    y1: 31.5925,
    x2: 593.756,
    y2: 27.6032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_594_27251",
    x1: 590.995,
    y1: 30.068,
    x2: 595.787,
    y2: 31.0706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_594_27251",
    x1: 442.085,
    y1: 188.99,
    x2: 443.119,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_594_27251",
    x1: 440.359,
    y1: 187.465,
    x2: 445.151,
    y2: 188.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_594_27251",
    x1: 652.818,
    y1: 35.966,
    x2: 653.852,
    y2: 31.9765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_594_27251",
    x1: 651.115,
    y1: 34.4474,
    x2: 655.908,
    y2: 35.4499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_594_27251",
    x1: 191.333,
    y1: 177.813,
    x2: 192.367,
    y2: 173.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_594_27251",
    x1: 189.607,
    y1: 176.289,
    x2: 194.399,
    y2: 177.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_594_27251",
    x1: 413.783,
    y1: 109.392,
    x2: 410.675,
    y2: 107.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_594_27251",
    x1: 412.502,
    y1: 110.015,
    x2: 414.015,
    y2: 107.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_594_27251",
    x1: 424.046,
    y1: 107.005,
    x2: 420.95,
    y2: 105.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_594_27251",
    x1: 422.771,
    y1: 107.616,
    x2: 424.284,
    y2: 105.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_594_27251",
    x1: 678.838,
    y1: 6.00394,
    x2: 675.742,
    y2: 4.47593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_594_27251",
    x1: 677.556,
    y1: 6.62722,
    x2: 679.07,
    y2: 4.12317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_594_27251",
    x1: 547.695,
    y1: 52.2107,
    x2: 544.598,
    y2: 50.6827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_594_27251",
    x1: 546.413,
    y1: 52.834,
    x2: 547.926,
    y2: 50.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_594_27251",
    x1: 137.173,
    y1: 235.671,
    x2: 131.409,
    y2: 232.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_594_27251",
    x1: 134.792,
    y1: 236.825,
    x2: 137.61,
    y2: 232.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_594_27251",
    x1: 214.646,
    y1: 6.77958,
    x2: 208.882,
    y2: 3.93494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_594_27251",
    x1: 212.265,
    y1: 7.93403,
    x2: 215.083,
    y2: 3.27128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_594_27251",
    x1: 140.054,
    y1: 214.846,
    x2: 136.958,
    y2: 213.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_594_27251",
    x1: 138.779,
    y1: 215.456,
    x2: 140.292,
    y2: 212.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_594_27251",
    x1: 221.321,
    y1: 34.0196,
    x2: 218.225,
    y2: 32.4917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_594_27251",
    x1: 220.046,
    y1: 34.6298,
    x2: 221.559,
    y2: 32.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_594_27251",
    x1: 150.374,
    y1: 222.995,
    x2: 150.828,
    y2: 219.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_594_27251",
    x1: 149.384,
    y1: 221.925,
    x2: 152.074,
    y2: 222.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_594_27251",
    x1: 156.433,
    y1: 79.344,
    x2: 153.337,
    y2: 77.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_594_27251",
    x1: 155.151,
    y1: 79.9672,
    x2: 156.664,
    y2: 77.4631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_594_27251",
    x1: 542.107,
    y1: 59.3085,
    x2: 539.011,
    y2: 57.7804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_594_27251",
    x1: 540.832,
    y1: 59.9187,
    x2: 542.345,
    y2: 57.4146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_594_27251",
    x1: 560.113,
    y1: 253.214,
    x2: 559.739,
    y2: 246.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_594_27251",
    x1: 557.995,
    y1: 251.582,
    x2: 563.013,
    y2: 251.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_594_27251",
    x1: 45.7442,
    y1: 239.697,
    x2: 45.3702,
    y2: 232.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_594_27251",
    x1: 43.6258,
    y1: 238.051,
    x2: 48.644,
    y2: 237.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_594_27251",
    x1: 484.74,
    y1: 170.581,
    x2: 490.265,
    y2: 162.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_594_27251",
    x1: 483.345,
    y1: 166.626,
    x2: 490.065,
    y2: 170.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_594_27251",
    x1: 85.3467,
    y1: 223.475,
    x2: 90.8721,
    y2: 215.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_594_27251",
    x1: 83.9401,
    y1: 219.512,
    x2: 90.6727,
    y2: 223.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_594_27251",
    x1: 821.549,
    y1: 206.132,
    x2: 821.549,
    y2: 184.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D2887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#311B7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#240E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_594_27251",
    x1: 815.124,
    y1: 200.649,
    x2: 830.898,
    y2: 200.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_594_27251",
    x1: 585.342,
    y1: 160.61,
    x2: 585.342,
    y2: 147.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#802C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#722B7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#532980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3D2882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#302783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_594_27251",
    x1: 581.602,
    y1: 157.403,
    x2: 590.778,
    y2: 157.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_594_27251",
    x1: 799.671,
    y1: 180.193,
    x2: 799.671,
    y2: 169.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#802C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#722B7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#532980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3D2882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#302783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_594_27251",
    x1: 796.519,
    y1: 177.503,
    x2: 804.252,
    y2: 177.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_594_27251",
    x1: 727.079,
    y1: 168.207,
    x2: 727.079,
    y2: 85.8675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D2887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#311B7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#240E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_594_27251",
    x1: 698.644,
    y1: 130.695,
    x2: 755.515,
    y2: 130.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01003E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_594_27251",
    x1: 720.254,
    y1: 113.077,
    x2: 755.515,
    y2: 113.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4513B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_594_27251",
    x1: 508.219,
    y1: 259.245,
    x2: 510.525,
    y2: 205.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D2887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#311B7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#240E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_594_27251",
    x1: 487.119,
    y1: 251.329,
    x2: 520.831,
    y2: 251.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01003E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_594_27251",
    x1: 487.119,
    y1: 232.692,
    x2: 502.532,
    y2: 232.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4513B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_594_27251",
    x1: 524.397,
    y1: 254.211,
    x2: 524.397,
    y2: 206.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6389FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5234DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_594_27251",
    x1: 178.016,
    y1: 186.882,
    x2: 178.832,
    y2: 168.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D2887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#311B7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#240E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_594_27251",
    x1: 170.667,
    y1: 184.066,
    x2: 182.595,
    y2: 184.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01003E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_594_27251",
    x1: 170.667,
    y1: 177.474,
    x2: 176.117,
    y2: 177.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4513B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_594_27251",
    x1: 183.85,
    y1: 185.071,
    x2: 183.85,
    y2: 168.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6389FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5234DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_594_27251",
    x1: 20.542,
    y1: 157.506,
    x2: 20.542,
    y2: 101.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D2887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#311B7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#240E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_594_27251",
    x1: 4.08704,
    y1: 147.751,
    x2: 33.885,
    y2: 147.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01003E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_594_27251",
    x1: 0,
    y1: 131.641,
    x2: 27.4606,
    y2: 131.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01003E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_594_27251",
    x1: 33.698,
    y1: 143.066,
    x2: 33.698,
    y2: 102.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6389FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5234DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_594_27251",
    x1: 91.9318,
    y1: 60.4018,
    x2: 91.9318,
    y2: 21.1756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D2887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#311B7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#240E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_594_27251",
    x1: 69.5332,
    y1: 55.0956,
    x2: 101.468,
    y2: 55.0956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01003E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_594_27251",
    x1: 99.0374,
    y1: 49.1984,
    x2: 108.868,
    y2: 49.1984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01003E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_594_27251",
    x1: 97.5814,
    y1: 49.8044,
    x2: 97.5814,
    y2: 21.1757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6389FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5234DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_594_27251",
    x1: 111.218,
    y1: 52.8787,
    x2: 111.218,
    y2: 30.8713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6389FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5234DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_594_27251",
    x1: 276.89,
    y1: 254.477,
    x2: 276.89,
    y2: 221.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_594_27251",
    x1: 265.631,
    y1: 248.95,
    x2: 279.655,
    y2: 248.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_594_27251",
    x1: 283.528,
    y1: 251.625,
    x2: 283.528,
    y2: 221.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6389FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5234DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_594_27251",
    x1: 376.061,
    y1: 195.254,
    x2: 376.061,
    y2: 172.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_594_27251",
    x1: 367.233,
    y1: 191.382,
    x2: 381.671,
    y2: 191.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_594_27251",
    x1: 381.404,
    y1: 190.081,
    x2: 381.404,
    y2: 172.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6389FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5234DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_594_27251",
    x1: 153.05,
    y1: 248.491,
    x2: 153.05,
    y2: 237.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_594_27251",
    x1: 148.643,
    y1: 246.555,
    x2: 155.855,
    y2: 246.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_594_27251",
    x1: 155.722,
    y1: 245.905,
    x2: 155.722,
    y2: 237.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6389FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5234DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_594_27251",
    x1: 49.0578,
    y1: 201.964,
    x2: 49.0578,
    y2: 181.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_594_27251",
    x1: 41.0975,
    y1: 198.476,
    x2: 54.12,
    y2: 198.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_594_27251",
    x1: 53.8662,
    y1: 197.308,
    x2: 53.8662,
    y2: 181.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6389FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5234DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_594_27251",
    x1: 145.384,
    y1: 156.678,
    x2: 145.384,
    y2: 145.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_594_27251",
    x1: 140.976,
    y1: 154.742,
    x2: 148.189,
    y2: 154.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_594_27251",
    x1: 148.055,
    y1: 154.092,
    x2: 148.055,
    y2: 145.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6389FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5234DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_594_27251",
    x1: 747.011,
    y1: 66.6283,
    x2: 746.889,
    y2: 55.6175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_594_27251",
    x1: 751.255,
    y1: 64.7189,
    x2: 744.296,
    y2: 64.7818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_594_27251",
    x1: 744.411,
    y1: 64.1738,
    x2: 744.317,
    y2: 55.6755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6389FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5234DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_594_27251",
    x1: 338.984,
    y1: 29.7259,
    x2: 338.984,
    y2: 18.3305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#250968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_594_27251",
    x1: 334.563,
    y1: 25.7279,
    x2: 341.789,
    y2: 25.7279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_594_27251",
    x1: 341.655,
    y1: 25.0775,
    x2: 341.655,
    y2: 16.2687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6389FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5234DD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingRocks);
export default __webpack_public_path__ + "static/media/floatingRocks.ada31715600b61d69cb4707c58b1fcb3.svg";
export { ForwardRef as ReactComponent };